<template>
	<div style="display: flex; width: 100%; height: 100%">
		<div style="flex: 1; margin-right: 20px">
			<div class="user_num">
				<div class="top_content">
					<div class="top_content_item">在线客服业务情况</div>
					<div style="margin-left: 20px" class="commonflex">
						<div>最后更新时间：</div>
						<div>{{ dayjs(nowTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
						<div class="commonflex">
							<img
								style="width: 14px; height: 14px; margin-left: 20px"
								src="../../assets/refresh.png"
								alt=""
							/>
							<div v-throttle="refresh" class="refresh">刷新</div>
						</div>
					</div>
				</div>
				<div style="display: flex; height: 93px">
					<div class="head_box">
						<div style="margin-left: 40px">
							<img class="imgs" src="../../assets/fefu.png" />
							<div class="head_text">坐席</div>
						</div>
						<div style="margin-left: 174px">
							<div>
								<span class="set_num">{{ customer.kefuOnline }}</span
								><span class="all_num">/</span><span class="all_num">{{ customer.kefuAll }}</span>
							</div>
							<div class="head_text" style="margin-top: 5px; text-align: center">在线/全部</div>
						</div>
					</div>
					<div style="display: flex; margin-left: 20px" class="head_box">
						<div style="margin-left: 40px">
							<img class="imgs" src="../../assets/meeting.png" />
							<div class="head_text">会话</div>
						</div>
						<div style="margin-left: 174px">
							<div>
								<span class="set_num">{{ customer.currentUserOnline }}</span
								><span class="all_num">/</span
								><span class="all_num">{{ customer.currentUserLineup }}</span>
							</div>
							<div class="head_text" style="margin-top: 5px; text-align: center">服务/排队</div>
						</div>
					</div>
				</div>
			</div>
			<div class="commonRow meet_box">
				<div class="record_list">
					<div class="record_list_title">
						<div>历史对话列表</div>
						<div>共{{ totalList }}条对话</div>
					</div>
					<div class="record_list_box">
						<div
							class="flex_common"
							style="flex-direction: column; margin-top: 20px"
							v-if="list.length == 0"
						>
							<img
								style="width: 40px; height: 40px"
								src="../../assets/none_thing/ChatDotRoun.png"
								alt=""
							/>
							<p class="none_thing">暂无会话</p>
						</div>
						<div v-else>
							<div
								:style="{ background: userIndex == index ? '#F7F7F7' : '#fff' }"
								v-for="(item, index) in list"
								:key="index"
								@click="dialogFn(item.userId, item.dialogue, index)"
							>
								<div v-if="item.dialogue" class="user_list">
									<div class="record_list_content flex_row">
										<div class="user_nickname">{{ item.dialogue.nickname }}</div>
										<div class="record_time" v-if="item.dialogue.createTime">
											{{ serviceTime(item.dialogue.createTime) }}
										</div>
									</div>

									<div
										v-if="item.dialogue.type !== 0 && item.dialogue.contentType == 1"
										class="record_text"
										v-html="item.dialogue.content"
									></div>
									<div
										v-else-if="item.dialogue.type !== 0 && item.dialogue.contentType == 2"
										class="record_text"
									>
										[图片]
									</div>
									<div v-else class="record_text">
										<span v-for="(it, ix) in item.dialogue.contentMultiple" :key="ix">
											{{ it }}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 分页器 -->
					<div class="pagination flex_box">
						<el-pagination
							:page-size="10"
							layout="prev, pager, next"
							size="small"
							:pager-count="5"
							:total="totalList"
							v-model="page"
							@current-change="CurrentChange"
						/>
					</div>
				</div>
				<div class="record_detail" :class="empty || historyRecord.length == 0 ? 'flex_center' : ''">
					<div style="text-align: center" v-show="empty || historyRecord.length == 0">
						<img
							style="width: 60px; height: 60px"
							src="../../assets/none_thing/none_record_image.png"
							alt=""
						/>
						<div>暂无聊天记录</div>
					</div>
					<div
						v-show="!empty && historyRecord.length != 0"
						class="chart_container"
						ref="recordDetail"
					>
						<div class="loadmore" ref="loadmore"></div>
						<div
							class="chart_item"
							v-for="(item, index) in historyRecord"
							:key="index"
							:style="{ flexDirection: item.type == 4 ? 'row' : 'row-reverse' }"
							:ref="
								(el) => {
									ref_messages_nodes[item.id] = el;
								}
							"
						>
							<div class="chart_head" v-if="item.nickname">
								<img
									style="width: 40px; height: 40px"
									src="../../assets/user_icon.png"
									v-if="item.type == 4"
								/>
								<img
									style="width: 40px; height: 40px"
									src="../../assets/head.png"
									v-else-if="item.type == 2"
								/>
								<img
									style="width: 40px; height: 40px"
									src="../../assets/kefu_head.png"
									v-else-if="item.type == 3"
								/>
								<div v-else-if="item.type == 0 || item.type == 1" style="width: 40px"></div>
							</div>
							<div v-else-if="!item.nickname" style="width: 40px"></div>
							<div
								class="chart_content"
								:style="{
									marginLeft: item.type == 4 ? '20px' : '0px',
									marginRight: item.type == 4 ? '0px' : '20px',
								}"
							>
								<div
									class="chart_name"
									:style="{
										textAlign: item.type == 4 ? 'left' : 'right',
										color: 'rgb(153, 153, 153)',
									}"
								>
									{{ item.type === 0 || item.type == 1 ? "" : item.nickname }}
								</div>

								<div
									class="flex_common"
									:style="{
										flexDirection: item.type == 4 ? 'row' : 'row-reverse',
										marginTop: '5px',
									}"
								>
									<div
										class="chart_item_content flex_common"
										:style="{
											padding: item.contentType == 2 ? '0' : '10px',
											backgroundColor:
												item.contentType == 2
													? 'transparent'
													: item.type == 4
													? '#FFFFFF'
													: item.type == 3 || item.type == 2
													? '#C194FF'
													: '#F5EEFF',
										}"
									>
										<div v-if="item.type == 0 || item.type == 1">
											<div style="color: #a15bff" class="chart_name">
												{{ item.nickname }}
											</div>
											<div
												class="replay_hot"
												v-for="(items, index) in item.contentMultiple"
												:key="index"
											>
												<div class="chart_name">
													{{ items }}
												</div>
											</div>
										</div>
										<el-image
											class="chatImg"
											v-if="item.contentType == 2"
											:src="item.content"
											:preview-src-list="[item.content]"
											:zoom-rate="1.2"
											:max-scale="7"
											:min-scale="0.2"
											:hide-on-click-modal="true"
											fit="contain"
										/>
										<div
											v-else
											v-html="item.content"
											style="white-space: pre-wrap; word-wrap: break-word"
											class="chart_name"
										></div>
									</div>
									<div
										v-if="item.nickname && item.type != 0 && item.type != 1"
										class="chart_name"
										:style="{
											color: item.type != 4 ? '#C194FF' : '#999999',
											marginLeft: item.type != 4 ? '0' : '20px',
											marginRight: item.type != 4 ? '20px' : '0px',
										}"
									>
										{{ dayjs(item.createTime).format("YYYY-MM-DD HH:mm") }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="record_user">
			<RightTab ref="refRightTab" :showReply="false" :showEmpty="showEmpty" />
		</div>
	</div>
</template>

<script setup>
import RightTab from "@/components/RightTab.vue";
import { ref, onActivated, onMounted, watch } from "vue";
import { get } from "../../utils/request";
import dayjs from "dayjs";
import { useRouter } from "vue-router";
const refRightTab = ref(null);
const recordDetail = ref(null);
const totalList = ref(0);
const userId = ref("");
const empty = ref(true);
const currentPage = ref(1);
const showEmpty = ref(true);
const observer = ref(null);
const page = ref(1);
const contentpage = ref(1);
const list = ref([]);
const customer = ref({});
const historyRecord = ref([]);
const hasNext = ref(false);
const userIndex = ref(-1);
const nowTime = ref(new Date());
const ref_messages_nodes = ref({});
const loadmore = ref(null);
const router = useRouter();
onActivated(() => {
	getHistoryRecord();
	refresh();
	userIndex.value = -1;
	if (historyRecord.value.length > 0) {
		let top_id = historyRecord.value[0].id;
		ref_messages_nodes.value[top_id].scrollIntoView();
	}
});

//获取历史会话
const getHistoryRecord = () => {
	get(`/api-cms/reception/list?page=${page.value}&size=10`).then((res) => {
		if (res.code == 1) {
			list.value = res.result.list;
			totalList.value = res.result.total;
		}
	});
};
//历史会话分页
const CurrentChange = (val) => {
	page.value = val;
	getHistoryRecord();
	userIndex.value = -1;
};
//获取用户历史数据
const dialogFn = (id, dialogue, index) => {
	if (userIndex.value == index) return;
	userId.value = id;
	userIndex.value = index;
	historyRecord.value = [];
	currentPage.value = 1;
	refRightTab.value.getUserInfo(id);
	hasNext.value = false;
	const box = document.querySelector(".chart_container");
	box.scrollTop = 0;
	if (observer.value) {
		observer.value.disconnect();
		observer.value = null;
	}
	get(
		`/api-cms/reception/dialogue?page=${contentpage.value}&size=10&userId=${id}&dialogueId=${dialogue.id}`,
		{},
	).then((res) => {
		if (res.code == 1) {
			empty.value = false;
			showEmpty.value = false;
			historyRecord.value = res.result.list.reverse();
			hasNext.value = res.result.hasNext;
			setTimeout(() => {
				recordDetail.value.scrollTop = recordDetail.value.scrollHeight;
				observer.value = new IntersectionObserver(
					(entries) => {
						let entry = entries[0].isIntersecting;
						if (entry) {
							if (hasNext.value) {
								loadMore(id, dialogue);
							}
						}
					},
					{
						root: null,
						rootMargin: "0px",
						threshold: 0.1,
					},
				);
				observer.value.observe(loadmore.value);

				// const box = recordDetail.value;
				// recordDetail.value.scrollTop = recordDetail.value.scrollHeight;
				// if (box && scrollListener.value) {
				// 	box.removeEventListener("scroll", scrollListener.value);
				// }
				// if (box) {
				// 	scrollListener.value = () => {
				// 		if (box.scrollTop === 0) {
				// 			if (hasNext.value) {
				// 				loadMore(id, dialogue);
				// 			}
				// 		}
				// 	};

				// 	// 监听滚动事件
				// 	box.addEventListener("scroll", scrollListener.value);
				// }
			}, 0);
		}
	});
};
// 客服时间
const serviceTime = (timestamp) => {
	const date = new Date(parseInt(timestamp));
	const now = new Date();

	// 获取年月日时分
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const day = date.getDate();
	const hours = date.getHours().toString().padStart(2, "0");
	const minutes = date.getMinutes().toString().padStart(2, "0");

	// 判断是否是当天
	if (date.toDateString() === now.toDateString()) {
		return `${hours}:${minutes}`;
	}

	// 判断是否是昨天
	const yesterday = new Date(now);
	yesterday.setDate(now.getDate() - 1);
	if (date.toDateString() === yesterday.toDateString()) {
		return `昨天 ${hours}:${minutes}`;
	}

	// 其他情况
	return `${year}-${month}-${day} ${hours}:${minutes}`;
};
//加载更多
const loadMore = (id, dialogue) => {
	currentPage.value++;
	get(
		`/api-cms/reception/dialogue?page=${currentPage.value}&size=10&userId=${id}&dialogueId=${dialogue.id}`,
		{},
		false,
	).then((res) => {
		if (res.code == 1) {
			hasNext.value = res.result.hasNext;
			historyRecord.value = [...res.result.list.reverse(), ...historyRecord.value];
		}
		setTimeout(() => {
			const length = res.result.list.length;
			let listIndex = length > 0 ? length - 1 : length;
			let top_id = historyRecord.value[listIndex].id;
			ref_messages_nodes.value[top_id].scrollIntoView();
		}, 0);
	});
};
const refresh = () => {
	get(`/api-cms/reception/report`)
		.then((res) => {
			if (res.code == 1) {
				customer.value = res.result;
				nowTime.value = new Date();
			}
		})
		.catch((err) => {});
};
</script>

<style scoped lang="less">
.commonflex {
	display: flex;
	align-items: center;
	justify-content: center;
}
.commonRow {
	display: flex;
	justify-content: space-between;
}
.user_num {
	.top_content {
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.refresh {
		margin-left: 4px;
		cursor: pointer;
		color: #9d58ff;
	}
}
.record_list {
	width: 240px;
	height: 100%;
	overflow: auto;
	border-right: 1px solid #c0bcbc;
	.record_list_title {
		text-align: center;
		font-size: 14px;
		color: #b7b7b7;
		border-bottom: 1px solid #dedede;
		padding: 19px 0;
		line-height: 22px;
	}
	.record_list_content {
		font-size: 14px;
		cursor: pointer;
		line-height: 22px;
		.user_nickname {
			flex: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.record_time {
			color: #b7b7b7;
			font-weight: 400;
		}
	}
	.record_text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin-top: 5px;
		font-size: 14px;
		color: #b7b7b7;
		:deep(p) {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-size: 14px;
		}
		:deep(h1) {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-size: 14px;
		}
	}
}
.record_user {
	overflow: auto;
	height: calc(100vh - 105px);
}
.pagination {
	height: 82px;
	position: absolute;
	width: 240px;
	bottom: 0;
	// border-top: 1px solid #dedede;
	z-index: 3;
	box-sizing: border-box;
}
.record_detail {
	flex: 1;
	overflow: auto;
	background-color: #f7f7f7;
}
.imgs {
	width: 32px;
	height: 32px;
}
.set_num {
	font-weight: bold;
	font-size: 36px;
	color: #ffffff;
	line-height: 22px;
}
.all_num {
	font-weight: bold;
	font-size: 36px;
	color: #c5a4ff;
	line-height: 22px;
}
.head_box {
	flex: 1;
	background: linear-gradient(272deg, #a15bff 0%, #6b31fe 100%), #d9d9d9;
	border-radius: 4px;
	display: flex;
	align-items: center;
}
.head_text {
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	line-height: 22px;
}
.top_content_item {
	font-weight: 500;
	font-size: 14px;
	color: #333333;
	line-height: 22px;
}
.meet_box {
	margin-top: 20px;
	height: calc(100vh - 230px);
	position: relative;
	background: #f7f7f7;
	border: 1px solid #dedede;
	border-radius: 4px;
	margin-top: 10px;
}
.el-pagination {
	--el-pagination-bg-color: #f7f7f7;
	--el-pagination-button-disabled-bg-color: #f7f7f7;
}
.record_list_box {
	width: 100%;
	height: calc(100% - 82px - 81px);
	overflow: auto;
	border-bottom: 1px solid #dedede;
}
.none_thing {
	font-size: 14px;
	color: #999999;
	line-height: 22px;
}
.chart_container {
	padding: 20px;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	// height: calc(100vh - 100px - 95px);
	overflow: auto;
	.chart_item {
		display: flex;
		// flex-direction: column;
		margin-top: 10px;
	}
	.chart_content {
		width: 100%;
	}
	.chart_item_content {
		border-radius: 4px;
		max-width: 70%;
		word-wrap: break-word;
	}
}
.loadmore {
	width: 100%;
	height: 20px;
}
.user_list {
	padding: 10px;
	cursor: pointer;
	height: 69px;
	box-sizing: border-box;
	overflow: hidden;
}
.replay_hot {
	margin-top: 10px;
}
.chart_name {
	font-weight: 400;
	font-size: 14px;
	color: #333333;
}
.chatImg {
	max-width: 150px;
	max-height: 150px;
	border-radius: 4px;
}
</style>
